import Tile from '../tile';
import { t } from 'ember-intl';
import Svg from 'tio-employee/components/svg';

const CommonQuestions = <template>
  <a
    href="https://tio.zendesk.com/hc/en-us"
    target="_blank"
    rel="noopener noreferrer"
    class="no-underline font-normal"
  >
    <Tile @headerText={{t "dashboard_tiles.common_questions"}}>
      <:description>
        <div class="flex flex-row">
          {{t "dashboard_tiles.get_answers_to"}}
        </div>
      </:description>
      <:image>
        <Svg
          @name="social-media-marketing"
          width="100%"
          height="100%"
          role="img"
          aria-label={{t "svg.social_media_marketing"}}
        />
      </:image>
    </Tile>
  </a>
</template>;

export default CommonQuestions;
